<template>
  <div class="body">
    <el-card class="card" shadow="never">
      <div class="header">
        <h3>{{$t('pdfInvite.padfTitle')}}</h3>
      </div>

      <div class="main">
        <div class="left">
          <img src="../../static/pdfimg1.png" alt="" />
          <img src="../../static/pdfimg2.png" alt="" />
        </div>

        <div class="right">
          <p class="title">
            {{$t('pdfInvite.tishi1')}} <br />
         {{$t('pdfInvite.tishi2')}}
          </p>
          <p>
           {{$t('pdfInvite.tishi3')}} <br />
            {{$t('pdfInvite.tishi4')}}
          </p>
          <el-button>
            <a href="./2024中国（西安）国际采矿展观众邀请函.pdf" download="2024中国（西安）国际采矿展观众邀请函.pdf" class="download">{{$t('pdfInvite.downd')}}</a>
          </el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
export default {
  name: 'pdfInvite',
  created() {},
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.body {
  //margin: 20px 30px 20px 30px;
  font-family: PingFangSC-Regular, PingFang SC;

  .header {
    padding: 0 0 20px 30px;
    border-bottom: 1px solid #e8e8e8;

    h3 {
      font-size: 20px;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
  }

  .main {
    //border: 1px solid red;
    margin: 40px 114px 0;
    display: flex;
    .left {
      width: 700px;
      img{
        width: 100%;
      }
      img:last-child{
        margin-top:30px ;
      }
    }
    .right {
      align-self: center;
      margin-left: 50px;
      p {
        font-size: 14px;
        color: #333333;
        line-height: 22px;
        font-weight: 400;
      }
      .title {
        color: #006fb8;
        font-size: 20px;
        line-height: 28px;
        font-weight: 500;
        font-family: PingFangSC-Medium, PingFang SC;
        margin-bottom: 16px;
      }
    }
  }
}
</style>

<style scoped>
>>> .el-card__body {
  padding: 20px 0;
}

>>> .el-button {
  background-color: #006fb8;
  color: #ffffff;
  min-width: 102px;
  height: 32px;
  padding: 0 5px;
  font-weight: 400;
  margin-top: 50px;
}
.el-button >>> .download {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  line-height: 22px;
  text-decoration: none;
}
</style>
